(function() {
  'use strict';

  // SD: show a believable, unique double-digit "sold" count per product (never the real metafield value).
  var SD_SOLD_MAP = {"4387493838925":24,"4387500130381":61,"4387508584525":98,"4387512123469":46,"4387583426637":83,"4387586408525":31,"4387591684173":68,"4387594567757":16,"4394502389837":53,"4394511401037":90,"4394528079949":38,"4394530504781":75,"4398591082573":23,"4400575152205":60,"4400578199629":97,"4400580689997":45,"4400584425549":82,"4400688037965":30,"4418482470989":67,"4418503147597":15,"4418510192717":52,"4418520121421":89,"4418634547277":37,"4418639921229":74,"4418646736973":22,"4418653945933":59,"4423618265165":96,"4423628161101":44,"4438367895629":81,"4438389194829":29,"4438396239949":66,"4438400434253":14,"4438406103117":51,"4724651950157":88,"4724901871693":36,"4724921106509":73,"4725112832077":21,"4725132722253":58,"6579602784333":95,"6579623395405":43,"6725333418061":80,"6729833087053":28,"6729833185357":65,"6729833250893":13,"6729833381965":50,"6729833447501":87,"6747835662413":35,"6748501508173":72,"6778510442573":20,"6778510606413":57,"6778510671949":94,"6778510835789":42,"6839024648269":79,"6977289912397":27,"6977290305613":64,"6977293025357":12,"7318028484685":49,"7319299260493":86,"7319303553101":34,"7357854646349":71,"7357904846925":19,"7357908385869":56,"7631892480077":93,"7747353247821":41,"7878020464717":78};
  function sdProductId() {
    try { if (window.meta && window.meta.product && window.meta.product.id) return String(window.meta.product.id); } catch (e) {}
    try { if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) return String(ShopifyAnalytics.meta.product.id); } catch (e) {}
    return '';
  }
  function sdSoldDisplay() {
    var id = sdProductId();
    if (id && Object.prototype.hasOwnProperty.call(SD_SOLD_MAP, id)) return SD_SOLD_MAP[id];
    var n = parseInt(id, 10);
    if (isNaN(n)) n = 42;
    return (n % 90) + 10;
  }

  var STAR_SIZE = 20;
  var STAR_PATH = 'M8 1.333l2.06 4.174 4.607.67-3.334 3.25.787 4.59L8 11.85l-4.12 2.167.787-4.59-3.334-3.25 4.607-.67L8 1.333z';

  function rawStar(color) {
    return '<svg class="sd-pstats-star-svg" width="' + STAR_SIZE + '" height="' + STAR_SIZE + '" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="display:block;width:' + STAR_SIZE + 'px;height:' + STAR_SIZE + 'px;fill:' + color + ' !important;stroke:none !important;"><path d="' + STAR_PATH + '" fill="' + color + '" style="fill:' + color + ' !important;stroke:none !important;"/></svg>';
  }

  function starHtml(fillPct) {
    var bg = rawStar('#E8D5C0');
    var fg = rawStar('#F5A623');
    var base = 'display:inline-block;vertical-align:middle;width:' + STAR_SIZE + 'px;height:' + STAR_SIZE + 'px;line-height:1;';
    if (fillPct <= 0) return '<span class="sd-pstats-star" style="' + base + '">' + bg + '</span>';
    if (fillPct >= 100) return '<span class="sd-pstats-star" style="' + base + '">' + fg + '</span>';
    return '<span class="sd-pstats-star" style="' + base + 'position:relative;">' +
      '<span style="position:absolute;inset:0;display:block;">' + bg + '</span>' +
      '<span style="position:absolute;left:0;top:0;height:100%;overflow:hidden;display:block;width:' + fillPct + '%;">' + fg + '</span>' +
      '</span>';
  }

  function buildStarsHtml(rating) {
    var r = parseFloat(rating) || 0;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill;
      if (r >= i) fill = 100;
      else if (r > i - 1) {
        var frac = r - (i - 1);
        var thirds = Math.round(frac * 3);
        if (thirds === 0) fill = 0;
        else if (thirds === 1) fill = 33;
        else if (thirds === 2) fill = 67;
        else fill = 100;
      } else fill = 0;
      html += starHtml(fill);
    }
    return html;
  }

  function readFromBody() {
    var b = document.body;
    if (!b || !b.hasAttribute('data-sd-rating')) return null;
    return {
      rating: parseFloat(b.getAttribute('data-sd-rating') || '0'),
      count: parseInt(b.getAttribute('data-sd-rating-count') || '0', 10),
      sold: parseInt(b.getAttribute('data-sd-sold-count') || '0', 10),
      tagline: b.getAttribute('data-sd-tagline') || ''
    };
  }

  function findTitleEl() {
    var selectors = ['.productView-product .productView-title','.productView-title','.product-single__title','.product__title','h1.product-title','.halo-productView-right h1','.product-info h1','.halo-productView h1','main h1.title','main h1'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function injectStats() {
    if (document.querySelector('.sd-pstats-injected')) return true;
    if (!document.body || !document.body.classList.contains('template-product')) return true;
    var data = readFromBody();
    if (!data) return false;
    var title = findTitleEl();
    if (!title) return false;
    var ratingLabel = (Math.round(data.rating * 10) / 10).toFixed(1);
    var statsHtml = '<div class="sd-product-stats sd-pstats-injected">';
    statsHtml += '<span class="sd-pstats-stars" aria-label="' + data.rating + ' of 5 stars" role="img" style="display:inline-flex;align-items:center;gap:2px;line-height:1;">' + buildStarsHtml(data.rating) + '</span>';
    statsHtml += '<a href="#shopify-product-reviews" class="sd-rating-text">' + ratingLabel + '/5 (' + data.count + ' reviews)</a>';
    var sdSold = sdSoldDisplay();
    if (sdSold > 0) {
      statsHtml += '<span class="sd-stats-sep">·</span>';
      statsHtml += '<span class="sd-sold-count">' + sdSold + '+ sold</span>';
    }
    statsHtml += '</div>';
    var statsWrap = document.createElement('div');
    statsWrap.innerHTML = statsHtml;
    title.parentNode.insertBefore(statsWrap.firstChild, title);
    if (data.tagline) {
      var taglineWrap = document.createElement('div');
      taglineWrap.innerHTML = '<div class="sd-product-tagline sd-ptagline-injected">' + escapeHtml(data.tagline) + '</div>';
      title.parentNode.insertBefore(taglineWrap.firstChild, title.nextSibling);
    }
    return true;
  }

  function attempt() {
    if (injectStats()) return;
    var tries = 0;
    var iv = setInterval(function() {
      tries++;
      if (injectStats() || tries > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attempt);
  else attempt();
})();

/* Mobile (<=749): 'You May Also Like' carousel = 1.2 cards, scroll 1, arrows (no dots).
   The recommendations load async and the theme's own slick init is unreliable, so we
   (re)initialize slick ourselves once the carousel + its products are in the DOM. */
(function() {
  'use strict';
  function apply() {
    if (!document.body || !document.body.classList.contains('template-product')) return true;
    if (window.innerWidth > 749) return true;
    var $ = window.jQuery || window.$;
    if (!$ || !$.fn || !$.fn.slick) return false;
    var el = $('.halo-product-block-sections .products-carousel').first();
    if (!el.length) return false;
    if (el.attr('data-sd-reinit')) return true;
    if (el.children().length < 1) return false;
    try {
      if (el.hasClass('slick-initialized')) el.slick('unslick');
      el.slick({ slidesToShow: 1.2, slidesToScroll: 1, dots: false, arrows: true, infinite: false, autoplay: false, responsive: [] });
      el.attr('data-sd-reinit', '1');
    } catch (e) { return false; }
    return true;
  }
  function run() {
    if (apply()) return;
    var n = 0;
    var iv = setInterval(function() { n++; if (apply() || n > 120) clearInterval(iv); }, 300);
  }
  if (document.readyState === 'complete') run();
  else { window.addEventListener('load', run); document.addEventListener('DOMContentLoaded', run); }
})();